(function ($, Swal) {
  document.body.addEventListener("CPB_ON_PRODUCT_MOUNTED", init);
  document.body.addEventListener('CPB_ON_KONVA_READY', playVideo)

  window.addEventListener('resize', function() {
    console.log('check resize')
    tabletPreview();
  })

  window.categoryWiseOptions = {};
  window.productCategory = document.querySelector("#product-builder[product-category]").getAttribute("product-category");
  window.universalOptions = window.universalOptions || [];

  const quizData = JSON.parse(localStorage.getItem("quizInfo")) || [];
  window.preSelectOption = false;
  if (quizData.length > 0) {
    const filteredData = quizData.filter(item => item.category === window.productCategory);
   
    if(filteredData.length > 0) {
      window.preSelectOption = true;
    }
  } 
  function init() {
    if(window.innerWidth < 1000){
      clickmobdots();
      document.querySelectorAll('#product-builder .buttonControlsWrapper .Polaris-Button')[0]?.classList.add('active-thumbnail');
    }
    titleSectionChanges();  
    bottomSection();
    setTimeout(() => {
      embroiderySettings();  
      selectStyleOptions();
    }, 1000);
    
    editStyles();
    panelTitleinfoMessages();
    addToCartButton();
    customAddToCartFunbtionality();
    addCustomTestimonials();
  }

  function playVideo() {
    function clickAndPlay() {
        const videoPreview = document.querySelector('.react-player__preview');

        if (videoPreview) {
            videoPreview.click();

            setTimeout(() => {
                  const video = document.querySelector('.swiper-slide-active').querySelector('video');
  
                  if (video) {
                      video.muted = true;
                      video.play();
                  }
            }, 1500)

            observer.disconnect();
        }
    }

    if (document.querySelector('.react-player__preview')) {
        clickAndPlay();
        return;
    }

    const observer = new MutationObserver(() => {
        if (document.querySelector('.react-player__preview')) {
            clickAndPlay();
        }
    });

    observer.observe(document.body, { childList: true, subtree: true });
    tabletPreview();
  }
  function clickmobdots(){
    document.addEventListener('click',(e) => {
      if(e.target.matches('#product-builder .buttonControlsWrapper .Polaris-Button')){
        document.querySelectorAll('#product-builder .buttonControlsWrapper .Polaris-Button').forEach((ele)=>{
          ele.classList.remove('active-thumbnail');
        })
        e.target.classList.add('active-thumbnail');
      }
    })
  }
  function customAddToCartFunbtionality() {
    if (!window._cpb.settings) window._cpb.settings = {};
    window._cpb.settings.addToCartOverride = async (data) => {
      if (window._cpb.settings.selling_plan) data.items[0].selling_plan = window._cpb.settings.selling_plan;
      data.items.forEach(item => {
        Object.keys(item.properties).forEach(key => {
          if((/Add Embroidery/).test(key)) {
            // item.properties[key]  = item.properties[key].split('(')[0];
            item.properties[key] = true;
          }
          if(key == "Preview Design") {
            delete item.properties[key]
          }
          if((/^View - /).test(key) || key === 'Measurements') {
            item.properties[`_${key}`] = item.properties[key] 
            delete item.properties[key]
          }
        });
        let productCategory = document.querySelector(`#product-builder[product-category='${window.productCategory}']`);
        if(window.universalOptions && window.universalOptions.length && productCategory && window.preSelectOption) {
          item.properties["_quizProduct"] = true;
          window.universalOptions.forEach(label => {
            if(label.value.includes("custom")) {
              if (label.addProperty == undefined) {
                item.properties[label.Type] = label.value.split("_")[1];
              }
            } else {
              item.properties[label.Type] = label.value;
            }
          });
        }
      })

      await fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
      if(window._cpbRedirectToCheckout === true) {
        location.href = '/checkout'
      } else {
        theme.cart.getCart().then(function(cart) {
          window._cartDrawer && window._cartDrawer.buildCart(cart, true);
          let productCategory = document.querySelector(`#product-builder[product-category='${window.productCategory}']`);
          if(productCategory && window.preSelectOption) {
           localStorage.removeItem("quizInfo");
          }
        })
      }      
    }
  }

  function addCustomTestimonials() {
    const reviewElement = document.createElement('div');
    let testImonialHtml = document.querySelector(".testimonial-container");;
    reviewElement.innerHTML = testImonialHtml.innerHTML;
    const swiperMainDiv = document.querySelector('.cpb-swiper-main');
    swiperMainDiv.appendChild(reviewElement);
    testImonialHtml.remove();
  }

  function addToCartButton() {

    function getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
          const [key, value] = cookie.trim().split('=');
          if (key === name) {
              return value;
          }
      }
      return null;
    }


    const buttonContainer = $(
      '<div class="cpbc-add-to-cart-button-container">'
    );
    let getProductPrice = document.querySelector(".cpb-custom-product-price").innerText.replace("US", "").replace(".00", "").trim();
    document.querySelector(".cpb-custom-product-price").innerText = getProductPrice;

    let getRegularProductPrice = document.querySelector(".cpb-regular-product-price").innerText.replace("US", "").replace(".00", "").trim();
    document.querySelector(".cpb-regular-product-price").innerText = getRegularProductPrice;
    
    const button = $(
      `<button type="button" class="cpbc-add-to-cart-button main-add-to-cart test">Add To Cart - ${getProductPrice} </button>`
    );

    buttonContainer.append(button);

    const realButton = $(".cpb-add-to-cart-button").eq(0);
    let stickyAddToCartBtn = $("[pro-add-to-cart]");
    button.on("click", () => {
      window._cpb.settings.selling_plan = undefined;
      realButton.trigger("click");
    });
    stickyAddToCartBtn.on("click", () => {
      window._cpb.settings.selling_plan = undefined;
      realButton.trigger("click");
    });
    const bottomSection = $(".cpb-custom-bottom-section");
    
    if (bottomSection.length) bottomSection.before(buttonContainer);
    else
      $(".cpb-panels-container .cpb-panel-wrapper")
        .eq(0)
        .parent()
        .append(buttonContainer);

    const fixedBottomBar = $('<div class="cpbc-bottom-actions-bar">');

    fixedBottomBar.append(
      // $(".cpb-custom-value-propositions").clone()
      $(".cpb-custom-value-propositions--fixed").show()
    );
    
    
    /*** BEGIN TRYNOW ***/


    const metaTag = document.querySelector(
      'meta[name="trynow:selling_plan_id"]'
    );
    let sellingPlanId = metaTag ? metaTag.getAttribute("content") : null;
    (async function() {
      if (!window.trynow) return;
      const sellingPlan = await window?.trynow.getSellingPlanId();
      sellingPlanId = parseInt(sellingPlan?.split('/')[4], 10);
    })();
  
    /* Added this on 3/10/24 to comment out the TBYB Button 
    Added this on 3/10/24 to comment out the TBYB Button */

    const tryNowButton = $(
      '<button type="button" id="trynow" name="add" class="cpbc-add-to-cart-button">Try Before You Buy</button>'
    );
   
    const tryNowDescription = $(
      '<span id="trynow-cta-description" style="display: inline-flex; color: black; flex-wrap: wrap; font-size: 12px; margin: 0 auto; justify-content: center;">Try your custom jeans at home for 7 days.&nbsp;' +
        "<div>" +
        '<span id="trynow-cta-learn-more" style="cursor: pointer; text-decoration: underline">Learn More</span>.&nbsp;' +
        "</div>" +
        '<a href="https://www.trynow.com/shopper" target="_blank" style="color: black; text-decoration: none; display: inline-flex">' +
        'Powered by&nbsp;<!-- BEGIN app snippet: trynow-logo --><svg width="40" style="position:relative;top:1px;left:0" viewBox="0 0 787 229">' +
        '<path fill="black" d="M547.051 33.393c-28.899 0-52.32 23.408-52.32 52.29v48.913c0 28.882 23.421 52.289 52.32 52.289 28.898 0 52.319-23.407 52.319-52.289V85.683c0-28.882-23.421-52.29-52.319-52.29Zm14.124 103.132c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V83.711c0-7.802 6.317-14.115 14.124-14.115s14.124 6.313 14.124 14.115v52.814ZM104.723 71.9V35.574H38.196V0H0v134.573c0 28.882 23.421 52.289 52.32 52.289 28.898 0 52.32-23.407 52.32-52.289V99.356H66.444v37.146c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V71.88h66.527v.02Zm88.008-38.509c-15.152 0-24.806 7.908-30.829 18.08V35.594h-37.818l-.105 148.269h38.195V83.73c0-7.802 6.317-14.116 14.124-14.116s14.124 6.314 14.124 14.116v37.146h38.196V85.66c0-28.882-12.025-52.29-35.887-52.29v.021Zm88.688 153.408c15.153 0 24.806-7.907 30.83-18.08v60.26h37.818l.105-192.672h-38.196v100.132c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V36.328h-38.196v98.182c0 28.882 12.025 52.289 35.887 52.289ZM442.247 33.393c-15.152 0-24.806 7.908-30.829 18.08V35.596H373.6l-.105 148.269h38.196V83.732c0-7.802 6.317-14.115 14.124-14.115s14.124 6.313 14.124 14.115v100.133h38.196V85.683c0-28.882-12.026-52.29-35.888-52.29Zm306.565 2.935V136.46c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116v-1.72s.042-.146.042-.23V36.328h-38.238v98.182s.021.147.042.23v1.72c0 7.803-6.317 14.116-14.124 14.116s-14.124-6.313-14.124-14.116V36.328h-38.195v98.182c0 28.882 16.453 52.289 44.596 52.289 22.12 0 36.013-13.759 40.924-28.609 4.932 14.85 18.804 28.609 40.924 28.609 28.143 0 44.597-23.407 44.597-52.289V36.328h-38.196Z"></path>' +
        "</svg>" +
        "</a>" +
        "</span>"
    );

tryNowDescription.find('#trynow-cta-learn-more').on('click', () => {
  window.dispatchEvent(new CustomEvent('tn-pdp-modal-open', {
    detail: { source: 'tn-pdp-learn-more' }
  }));
});
    
    const tryNowHIWModal = $(
      '<div style="display: none; position: fixed; z-index: 10000000; left: 0px; top: 0px; width: 100%; height: 100%; background-color: rgba(0, 0, 0, 0.4); font-family: Breno, Arial, sans-serif; color: rgb(0, 0, 0);">' +
        '<div style="background-color: rgb(255, 255, 255); margin: auto; padding: 16px 20px; border: 1px solid rgb(136, 136, 136); width: 317px; height: fit-content; top: calc(50% - 156.5px); position: relative; text-align: center; border-radius: 10px;">' +
          '<div style="font-size: 8px; line-height: 12px;">' +
            '<img alt="TryNow Logo" src="https://components.trynow.net/shopify/7.2.5/images/trynow_logo.svg" width="65" />' +
            '<div style="font-size: 13px; letter-spacing: normal; line-height: normal; margin-top: 2px; font-weight: 100; transform: scale(0.85, 1);">in partnership with Neems</div>' +
         ' </div>' +
          '<span style="position: absolute; top: 15px; right: 15px; font-size: 20px; cursor: pointer; line-height: 14px; font-weight: 100;">×</span>' +
          '<h2 style="margin-bottom: 10px; margin-top: 28px; letter-spacing: normal; font-weight: 140; font-size: 30px; line-height: normal; transform: scale(0.85, 1);">Try before you buy</h2>' +
          '<div style="padding: 7px 20px; margin: auto; width: fit-content; border-radius: 20px; border: 1px solid rgb(0, 0, 0); display: flex; gap: 5px; line-height: normal; align-items: end;">' +
            '<svg width="20" height="20" viewBox="0 0 24 24" fill="none">' +
              '<path d="M21 10H3M16 2V6M8 2V6M7.8 22H16.2C17.8802 22 18.7202 22 19.362 21.673C19.9265 21.3854 20.3854 20.9265 20.673 20.362C21 19.7202 21 18.8802 21 17.2V8.8C21 7.11984 21 6.27976 20.673 5.63803C20.3854 5.07354 19.9265 4.6146 19.362 4.32698C18.7202 4 17.8802 4 16.2 4H7.8C6.11984 4 5.27976 4 4.63803 4.32698C4.07354 4.6146 3.6146 5.07354 3.32698 5.63803C3 6.27976 3 7.11984 3 8.8V17.2C3 18.8802 3 19.7202 3.32698 20.362C3.6146 20.9265 4.07354 21.3854 4.63803 21.673C5.27976 22 6.11984 22 7.8 22Z" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>' +
           ' </svg>' +
            '<div style="font-size: 16px; font-weight: 100; letter-spacing: normal; transform: scale(0.85, 1);">7 days</div>' +
         ' </div>' +
          '<ul style="list-style: none; padding: 20px 5px; background-color: rgb(245, 245, 245); width: fit-content; border-radius: 10px; margin: 30px auto 15px; text-align: center;">' +
            '<li style="font-weight: 100; transform: scale(0.85, 1); display: grid; grid-template-columns: 20px auto; width: 100%; align-items: center;">' +
              '<div style="margin-right: 10px; height: 100%; width: fit-content; display: grid; grid-template-rows: min-content;">' +
                '<div style="width: 10px; height: 10px; background-color: rgb(214, 214, 214); border-radius: 50%; display: block; margin-top: 4px;"></div>' +
                '<div style="width: 2px; background-color: rgb(214, 214, 214); height: 100%; min-height: 10px; margin: auto; display: block;"></div>' +
             ' </div>' +
              '<div style="margin-top: unset; margin-bottom: auto; line-height: normal; font-size: 13px; text-align: left; letter-spacing: normal;">Try at home for 7 days after delivery.</div>' +
           ' </li>' +
            '<li style="font-weight: 100; transform: scale(0.85, 1); display: grid; grid-template-columns: 20px auto; width: 100%; align-items: center;">' +
              '<div style="margin-right: 10px; height: 100%; width: fit-content; display: grid; grid-template-rows: min-content;">' +
                '<div style="width: 2px; background-color: rgb(214, 214, 214); height: 100%; min-height: 10px; margin: auto; display: block;"></div>' +
                '<div style="width: 10px; height: 10px; background-color: rgb(214, 214, 214); border-radius: 50%; display: block;"></div>' +
                '<div style="width: 2px; background-color: rgb(214, 214, 214); height: 100%; min-height: 10px; margin: auto; display: block;"></div>' +
             ' </div>' +
              `<div style="margin-top: auto; margin-bottom: auto; line-height: normal; font-size: 13px; text-align: left; letter-spacing: normal;">Easily return what you don't love.</div>` +
           ' </li>' +
            '<li style="font-weight: 100; transform: scale(0.85, 1); display: grid; grid-template-columns: 20px auto; width: 100%; align-items: center;">' +
              '<div style="margin-right: 10px; height: 100%; width: fit-content; display: grid; grid-template-rows: min-content;">' +
                '<div style="width: 2px; background-color: rgb(214, 214, 214); height: 100%; min-height: 10px; margin: auto; display: block;"></div>' +
                '<div style="width: 10px; height: 10px; background-color: rgb(214, 214, 214); border-radius: 50%; display: block; margin-bottom: 4px;"></div>' +
             ' </div>' +
              '<div style="margin-top: auto; margin-bottom: unset; line-height: normal; font-size: 13px; text-align: left; letter-spacing: normal;">Only pay for what you keep.</div>' +
           ' </li>' +
         ' </ul>' +
          '<button style="width: 92%; padding: 14px 20px; background-color: rgb(0, 0, 0); color: rgb(255, 255, 255); border: none; cursor: pointer; margin-top: 5px; border-radius: 5px; font-weight: 140; font-size: 14px; font-family: Breno, Arial, sans-serif; display: none;">' +
            '<div style="transform: scale(0.85, 1);">Enable Try Before You Buy</div>' +
         ' </button>' +
          '<div style="text-decoration: underline; cursor: pointer; width: fit-content; margin: 14px auto 20px; font-size: 13px; text-underline-offset: 5px; font-weight: 100; letter-spacing: normal; transform: scale(0.85, 1); display: none;">Not right now</div>' +
       ' </div>' +
     ' </div>'
    );

    const tryNowHIWModalContainer = $('<trynow-hiw-modal></trynow-hiw-modal>');

    buttonContainer.append(tryNowButton);

    buttonContainer.append(tryNowDescription);

    buttonContainer.append(tryNowHIWModalContainer.append(tryNowHIWModal));

    buttonContainer.attr(
      "style",
      "flex-wrap: wrap; gap: 15px; align-content: space-around; height: fit-content;"
    );

    tryNowButton.attr(
      "style",
      "background-color: white; border: 2px solid #000; color: #000;"
    );
    // let getProVariants = document.querySelector("[data-product-variants]");
    // if(getProVariants) {
    //   let variantObject = JSON.parse(getProVariants.innerText).product_variant;
    //   console.log(variantObject, "variantObject")
    //   if(variantObject.selling_plan_allocations) {
    //     sellingPlanId = variantObject.selling_plan_allocations[0].selling_plan_id;
    //   }
    // } 
    let stickyTryBeforeYouBuy = $("[pro-try-before-buy]");
    stickyTryBeforeYouBuy.on("click", () => {
      window._cpb.settings.selling_plan = sellingPlanId;
      realButton.trigger("click");
    });
    tryNowButton.on("click", () => {
      window._cpb.settings.selling_plan = sellingPlanId;
      realButton.trigger("click");
    });

    
    /*** END TRYNOW ***/

    

    new ResizeObserver(() => {
      fixedBottomBar.attr(
        "style",
        "--section-width:" + buttonContainer.width() + "px;"
      );
    }).observe(buttonContainer[0]);

    const builder = $("#product-builder");
    new ResizeObserver(() => {
      builder.attr("style", "--builder-width:" + builder.width() + "px;");
    }).observe(builder[0]);

    function getDistanceFromTop(element) {
      const rect = element.getBoundingClientRect();
      return rect.top;
    }

    function getDistanceFromTop(element) {
      const rect = element.getBoundingClientRect();
      return rect.top;
    }

    builder.append(fixedBottomBar);

    new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting === false)
        fixedBottomBar.addClass("cpbc-show");
      else fixedBottomBar.removeClass("cpbc-show");
    }).observe(bottomSection[0]);
   
    let addToCartContainer = $(".cpbc-add-to-cart-button-container");
    let stickyBeforeSelection = $(".cpbc-bottom-actions-new.before_selection");
    let stickyAfterSelection = $(".cpbc-bottom-actions-new.after_selection");
    let getUnactivatedOption;

    const observer = new IntersectionObserver((entries) => {
      const entry = entries[0];
      const distanceFromTop = getDistanceFromTop(addToCartContainer[0]);
      let panels = document.querySelectorAll("#product-builder .option-container");
      let totalCategory = panels.length - 1;
      const activePanelCount = [...panels].filter(panel => panel.querySelector('.cpb-active')).length;
      getUnactivatedOption = [...panels].filter(panel => !panel.querySelector('.cpb-active'))[0];
      let optionsTitle = getUnactivatedOption.querySelector(".cpb-panel-title").innerText;
      var remainingOptionTitle = "Get Started";
    
      let isMeasurementChecked;
      if(document.querySelector(".cpb-checkbox input[type='checkbox']")) {
        isMeasurementChecked = document.querySelector(".cpb-checkbox input[type='checkbox']").checked;
      }
      if(activePanelCount > 0) {
        if(totalCategory != activePanelCount || !isMeasurementChecked) { 
          remainingOptionTitle = `Finish Building Your Jeans`;
        } else {
          remainingOptionTitle = `Your Custom Jeans Are Ready!`;
        }
      }
      let getStartedToCustomizeEle = $("[data-get-started]");
    
      $(getStartedToCustomizeEle).text(`${remainingOptionTitle}`);
      if(totalCategory == activePanelCount && isMeasurementChecked) {
        if (!entry.isIntersecting && distanceFromTop < 0) {
          stickyAfterSelection.addClass("cpbc-show");
          // $("#tolstoyWidgetElement").hide();
        } else {
          stickyAfterSelection.removeClass("cpbc-show");
          // $("#tolstoyWidgetElement").show();
        }
      } else {
        if (!entry.isIntersecting && distanceFromTop < 0) {
          stickyBeforeSelection.addClass("cpbc-show");
          // $("#tolstoyWidgetElement").hide();
        } else {
          stickyBeforeSelection.removeClass("cpbc-show");
          // $("#tolstoyWidgetElement").show();
        }
      }
    }, { threshold: 1.0 });
    observer.observe(addToCartContainer[0]); 

    let getStartedToCustomize = $("[data-get-started]");
    $(getStartedToCustomize).on("click", () => {
      let panels = document.querySelectorAll("#product-builder .option-container");
    let getUnactivatedOption = [...panels].filter(panel => !panel.querySelector('.cpb-active'))[0];
   
    // let scrollTo = $('.Stretch-option').offset().top - 100;
    // $('html, body').animate({ scrollTop: scrollTo }, 300);
      $([document.documentElement, document.body]).animate({
          // scrollTop: $("#product-builder").offset().top
          scrollTop: $(getUnactivatedOption).offset().top - 100
      }, 1000);
    });
  }

  function panelTitleinfoMessages() {
    const infoMessagesInfo = {};
    CPB.getStore()
      .getState()
      .Product.panels.forEach((panel) => {
        const infoMessage = {};
        if (panel.extraClassName.includes("info-message--js") === false) return;
        infoMessage.title = panel.metafields?.find(
          (metafield) => metafield.key === "info-message-title"
        )?.value;
        infoMessage.image = panel.metafields?.find(
          (metafield) => metafield.key === "info-message-image"
        )?.value;
        if (infoMessage.title && infoMessage.image)
          infoMessagesInfo[panel.id] = infoMessage;
      });
    updateDOM();
    document.body.addEventListener("CPB_ON_UPDATE_CURRENT_TAB", updateDOM);
    document.body.addEventListener("CPB_ON_OPTIONS_UPDATE", () => {
      setTimeout(updateDOM, 0);
    });

    function updateDOM() {
      $(".cpb-panel-wrapper.info-message--js").each(function () {
        const panel = $(this);
        const title = panel.find(".cpb-panel-title");
        if (title.find(".cpbc-info-message-button").length > 0) return;
        const panelId = panel.attr("data-panel-id");
        if (infoMessagesInfo[panelId] === undefined) return;
        const button = $(
          `<button type="button" class="cpbc-info-message-button" aria-label="open ${infoMessagesInfo[panelId].title}">${infoMessagesInfo[panelId].title}</button>`
        );
        button.on("click", () => {
          Swal.fire({
            title: `<strong>${infoMessagesInfo[panelId].title}</strong>`,
            html: `<div class="cpbc-info-message-image-container"><img src="${infoMessagesInfo[panelId].image}" alt=""/></div>`,
            showCloseButton: true,
            customClass: {
              container: "cpbc-info-message",
            },
          });
        });
        title.append(button);
      });
    }
  }

  function editStyles() {
    const elems = [
      ...document.querySelectorAll(
        ".cpb-panel-categories-container .cpb-category-inputLong"
      ),
    ];
    elems.map((elem) => {
      elem.style.width = "100%";
      if (window.innerWidth > 1080) {
        elem.querySelector(".option-type-inputLong").style.width = "70%";
      }
      elem.querySelector(".option-type-inputLong").style.width = "100%";
    });
  }

  function getProductVideos() {
    const videos = [];
    let category;
    CPB.getStore()
      .getState()
      .Product.panels.find((panel) => {
        category = panel.categories.find((category) =>
          category.extraClassName.includes("cpbc-product-videos")
        );
        return category;
      });
    if (!!category === false) return videos;
    category.options.forEach((option) => {
      if (!!option.option.data.value === false) return;
      const video = {
        // full: `https://drive.google.com/uc?export=download&id=${option.option.data.value}`,
        full: option.option.data.value,
        description: option.optionDescription,
        title: option.metafields?.find((metafield) => metafield.key === "title")
          ?.value,
      };
      if (option.option.data.label)
        // video.short = `https://drive.google.com/uc?export=download&id=${option.option.data.label}`;
        video.short = option.option.data.label
      else video.short = video.full;
      videos.push(video);
    });
    return videos;
  }

  const iconMaximize = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
    <path d="M12.75 3.5a.75.75 0 0 0 0 1.5h1.19l-3.22 3.22a.75.75 0 0 0 1.06 1.06l3.22-3.22v1.19a.75.75 0 0 0 1.5 0v-3a.75.75 0 0 0-.75-.75h-3Z" fill="#000"/>
    <path d="M7.25 16.5a.75.75 0 0 0 0-1.5h-1.19l3.22-3.22a.75.75 0 1 0-1.06-1.06l-3.22 3.22v-1.19a.75.75 0 0 0-1.5 0v3c0 .414.336.75.75.75h3Z" fill="#000"/>
    </svg>`;

  class ProductVideoModal {
    constructor() {
      this.container = $('<div class="cpbc-product-videos-modal">');
      this.closeButton = $(
        '<button type="button" class="cpbc-product-videos-modal-close">'
      ).attr("aria-label", "Close");
      this.title = $("<h2>").text("Made From Scratch to Fit You");
      this.main = $('<div class="cpbc-product-videos-modal-main">');
      this.videoContainer = $(
        '<div class="cpbc-product-videos-modal-video-container">'
      );
      this.fullScreenButton = $(
        '<button type="button" class="cpbc-product-videos-modal-full-screen">'
      ).html(iconMaximize);
      this.textContainer = $(
        '<div class="cpbc-product-videos-modal-text-container">'
      );
      this.container.append(this.closeButton, this.title, this.main);
      this.main.append(this.videoContainer, this.textContainer);
      if (this.container[0].requestFullscreen)
        this.fullScreenFunctionName = "requestFullscreen";
      else if (this.container[0].webkitRequestFullscreen)
        this.fullScreenFunctionName = "webkitRequestFullscreen";
      else if (this.container[0].msRequestFullScreen)
        this.fullScreenFunctionName = "msRequestFullScreen";
      else this.fullScreenButton.hide();
      if (this.fullScreenFunctionName) {
        this.fullScreenButton[0].addEventListener("click", () => {
          this.openFullScreen();
        });
      }
      this.closeButton.on("click", () => {
        this.close();
      });
      new ResizeObserver(() => {
        this.container[0].style.setProperty(
          "--titleHeight",
          this.title.outerHeight(true) + "px"
        );
      }).observe(this.title[0]);
      new ResizeObserver(() => {
        this.container[0].style.setProperty(
          "--textContainerHeight",
          this.textContainer.outerHeight() + "px"
        );
      }).observe(this.textContainer[0]);
      new ResizeObserver(() => {
        this.container[0].style.setProperty(
          "--modalHeight",
          this.container.height() + "px"
        );
      }).observe(this.container[0]);
    }
    openVideo(url, description) {
      const video = $(
        '<video controls muted playsinline autoplay height="720" width="406">'
      );
      const source = $(`<source src="${url}" type="video/mp4">`);
      this.videoElement = video;
      this.sourceElement = source;
      video.append(source);
      this.videoContainer.empty().append(this.fullScreenButton, video);
      this.textContainer.html(description);
      $("body").append(this.container).addClass("cpbc-video-modal-opened");
    }
    close() {
      this.container.detach();
      $("body").removeClass("cpbc-video-modal-opened");
    }
    openFullScreen() {
      this.videoElement[0][this.fullScreenFunctionName]();
    }
  }

  function getProductVideosHTML(videos) {
    if (videos.length === 0) return;
    const productModal = new ProductVideoModal();
    const container = $('<div class="cpbc-product-videos">').append(
      $("<h2>").text("Neems in Action")
    );
    videos.forEach((video, i) => {
      const videoContainer = $(`<button class="cpbc-product-video-container">`);
      videoContainer[0].fullVideoUrl = video.full;
      videoContainer[0].videoDescription = video.description;
      const videoEl = $('<video width="406" height="720" muted autoplay loop playsinline>');
      const sourceEl = $(`<source src="${video.short}" type="video/mp4">`);
      videoEl.append(sourceEl);
      videoContainer.append(videoEl);
      if (video.title)
        videoContainer.append(
          $('<div class="cpbc-product-video-container__title">').text(
            video.title
          )
        );
      container.append(videoContainer);
      videoContainer.on("click", () => {
        productModal.title.text(
          `Neems in Action (${i + 1} of ${videos.length})`
        );
        productModal.openVideo(video.full, video.description);
      });
    });
    return container;
  }

  function bottomSection() {
    const section = $('<div class="cpb-custom-bottom-section">');
    const propositions = $(".cpb-custom-value-propositions").first();
    const additionalInfo = $(".cpb-custom-more-information");
    const influencerSection = $(".cpb-custom-influencer-wrapper");
    const jeansCustomizeSteps = $(".cpb-custom-steps-wrapper");
    const newPriVideos = $(".new-custom-videos");
    if ($(".cpb-selection-summary").before(section).length === 0)
      $(".cpb-panels-container .cpb-panel-wrapper")
        .eq(0)
        .parent()
        .append(section);
    const productVideos = getProductVideosHTML(getProductVideos());
    const productModal = new ProductVideoModal();
    $(".open-video-modal").on("click", (evt) => {
      let url = $($(evt)[0].currentTarget).attr("data-video-url");
      let videoIndex = $(evt.currentTarget).attr("data-current-index");
      let description = $(`[data-video-container="${videoIndex}"]`).html();
      productModal.openVideo(url, description);
    });
    section.append(propositions);
    // if (productVideos) section.append(productVideos);
    section.append(newPriVideos);
    section.append(influencerSection);
    section.append(jeansCustomizeSteps);
    section.append(additionalInfo);
    if (propositions) propositions.show();
    if (influencerSection) influencerSection.show();
    if(jeansCustomizeSteps) jeansCustomizeSteps.show();
    if (additionalInfo) additionalInfo.show();
    if(newPriVideos) newPriVideos.show();
    
    let topAfterpay = document.querySelector(".cpb-custom-title-section afterpay-placement").shadowRoot; 
    if(topAfterpay) {
      let afterPayValue = topAfterpay.querySelector(".afterpay-main-text").innerText;
      let afterPayEle = document.querySelector(".after_selection afterpay-placement").shadowRoot.querySelector(".afterpay-paragraph");
      let element = document.querySelector(".after_selection afterpay-placement").shadowRoot.querySelector(".afterpay-paragraph .afterpay-text2");
      let afterpayIcon = document.querySelector(".after_selection afterpay-placement").shadowRoot.querySelector(".afterpay-paragraph .afterpay-link");
      let afterPayLogo = document.querySelector(".after_selection afterpay-placement").shadowRoot.querySelector(".afterpay-paragraph .afterpay-logo");
      const priceRegex = /\$\d+/;
      const matchPrice = afterPayValue.match(priceRegex);
      if(matchPrice.length) {
        afterpayIcon.style.display = "none";
        afterPayEle.style.display = "flex";
        afterPayLogo.style.order = "1";
        afterPayEle.style.gap = "5px";
        element.innerText = `Pay in 4 payments of ${matchPrice} with`;
        topAfterpay.querySelector(".afterpay-main-text").innerText = `Pay in 4 payments of ${matchPrice} with`;
        topAfterpay.querySelector(".afterpay-main-text").style.marginRight = "6px";
      }
    }
  }

  function embroiderySettings() {
    const options = document.querySelectorAll('.cpb-option');
    options.forEach(option => {
      const label = option.querySelector('.cpb-option-label') || 
      option.closest('.option').querySelector('.cpb-option-label') || 
      option.closest('.option-type-text').querySelector('.cpb-option-type-text > div') ||
      option.querySelector('span > div');
      if(label.textContent.trim().replace(/\s+/g, '').toLowerCase() == "specificrise" || label.textContent.trim().replace(/\s+/g, '').toLowerCase() == "specificinseam") {
        if(option.closest('.option-type-img') != null){
          option.closest('.option-type-img').classList.add("option--hide");
        } else{
          option.parentElement.classList.add("option--hide");
        } 
      }   
    }); 
    let productCategory = document.querySelector(`#product-builder[product-category='${window.productCategory}']`);
    var embroiderySection = document.querySelector(".embroidery--button");
    const embroideryTitle = document.querySelector(".embroidery--button .cpb-panel-title");
    let embroideryBtnWrapper = document.querySelector(".embroidery--button .embroidery-button-wrapper");
    const subtext = document.querySelector(".embroidery--button .subtext");
    const filteredOptions = quizData.filter(item => item.category === window.productCategory);
    const targetContainer = document.querySelector(".cpb-panels-container");
    let productDescription = document.querySelector(".cpb-product-description");
    
    if(productCategory) {


      setTimeout(()=>{
        embroideryPriceChange();
      },500)

      if(localStorage.getItem("discountCode") != null){
        setTimeout(()=>{
          changePriceonDiscount();
        },300)  
        const categoryWiseOptions = saperateQuizOptions();
        window.categoryWiseOptions = categoryWiseOptions;
        setTimeout(() => {
          selectOptionsSequentially(categoryWiseOptions);
        }, 1500); 
      }

      

      document.addEventListener("DOMContentLoaded", updateEmbroideryButton);

      function saperateQuizOptions() {
        const quizData = JSON.parse(localStorage.getItem("quizInfo")) || [];
        if (quizData.length === 0) return; 
        const filteredData = quizData.filter(item => item.type === "main" || item.category === window.productCategory);
        const categoryWiseOptions = [];
        const typeMap = {}; 
    
        filteredData.forEach(item => {
          const values = Array.isArray(item.answer)
            ? item.answer
                .filter(ans => ans.value.trim() !== "")
                .map(ans => ans.measurementValue && ans.measurementValue.trim() !== "" 
                    ? `custom_${ans.measurementValue}` 
                    : ans.value)
            : item.answer.value.trim() !== ""
                ? [item.answer.value]
                : [];

    
            if (values.length > 0) {
                let type = item.type;
                if (item.type === "main") {
                    type = "Shopping Concern"; 
                }
                if (item.answer.sectionType === "notes") {
                    type = "Notes";
                }
    
                if (item.type === "main") {
                    categoryWiseOptions.push({
                        title: item.title,
                        type: type,
                        value: values.join(", ")
                    });
                } else {
                    typeMap[item.type] = {
                        title: item.title,
                        type: item.type,
                        value: values.join(", ")
                    };
                }
            }
        });
    
        return [...categoryWiseOptions, ...Object.values(typeMap)];
      }

      function selectOptionsSequentially(categoryWiseOptions) { 
        if(categoryWiseOptions == undefined) return;

          let labelsToMatch = [];
          let optionTypes = ["Style", "Wash", "Rise", "Stretch", "Length", "length"];
          let isBootcutOrSkinny = false; // Initialize flag outside the loop

          categoryWiseOptions.forEach(item => {
            if (item.type.toLowerCase() == "fit" || item.type.toLowerCase() == "flare" || item.type == "Shopping Concern" || item.type == "Notes") {
              if(item.value.trim() != "Women's" && item.value.trim() != "Men's") {
                window.universalOptions.push({Type: item.type, value: item.value.trim()}); // Store main type values separately
              }
            }
          
            if(item.value.trim().includes("custom")) {
              window.universalOptions.push({Type: `custom_${item.type}`, value: item.value.trim()});
            }
          });

          optionTypes.forEach(type => {
              const matchingItems = categoryWiseOptions.filter(item => item.type === type);
             
              matchingItems.forEach(item => {
                let value = item.value.trim();
                
                // To select the custom value 
               
                if(value.includes("custom")) {
                  const options = document.querySelectorAll(`.${item.type.toLowerCase()}-option .cpb-option`);
                  const clickOption = (option) => {
                      return new Promise(resolve => {
                          setTimeout(() => {
                              const label = option.querySelector('.cpb-option-label') || 
                                            option.closest('.option').querySelector('.cpb-option-label') || 
                                            option.closest('.option-type-text').querySelector('.cpb-option-type-text > div') ||
                                            option.querySelector('span > div');
                              if (label && label.textContent.includes("Specific")) {
                                option.parentElement.classList.remove("option--hide");
                                  if(option) option.click();
                              } 
                              resolve(); // Resolve after clicking
                          }, 100); 
                      });
                  };
              
                  const clickOptionsSequentially = async () => {
                      for (let option of options) {
                        await clickOption(option); // Wait for each click to finish
                      }
                  };
              
                  clickOptionsSequentially(); // Start the process
                }
              
                if (item.type === "Style" && (value.toLowerCase() === "bootcut" || value.toLowerCase() === "skinny")) {
                    isBootcutOrSkinny = true;
                }
                if (value === "Ultra High Rise") {
                  value = "Ultra High"; 
                }
                if (value === "Mid Rise") {
                    value = "Mid"; 
                }
                if (value === "High Rise") {
                  value = "High"; 
                }
                if (value === "Low Rise") {
                  value = "Low"; 
                }
              
                if (item.type === "Stretch" && isBootcutOrSkinny) {
                    value = "Stretch";
                } else if(isBootcutOrSkinny) {
                  if (labelsToMatch.indexOf("Stretch") === -1) {
                    labelsToMatch.push("Stretch");
                  }
                }

                // Push the final value to the array
                labelsToMatch.push(value);
                // labelsToMatch.push("Stretch");
               
                
                if (item.type === "Stretch") {
                    isBootcutOrSkinny = false;
                }
              });
          });
          const uniqueArr = [...new Set(labelsToMatch)];
          const options = document.querySelectorAll('.cpb-option');
          let index = 0;
    
          function clickNextOption() {
              if (index >= uniqueArr.length) {
                if(document.querySelector('.cpb-checkbox[aria-checked="false"] label') != null){
                  console.log('hey',document.querySelector('.cpb-checkbox[aria-checked="false"] label'))
                  document.querySelector('.cpb-checkbox[aria-checked="false"] label').click();
                }
                return; 
              }
      
              let clicked = false;
              options.forEach(option => {
                  const label = option.querySelector('.cpb-option-label') || 
                  option.closest('.option').querySelector('.cpb-option-label') || 
                  option.closest('.option-type-text').querySelector('.cpb-option-type-text > div') ||
                  option.querySelector('span > div');
                
                  if (label && label.textContent.trim().replace(/\s+/g, '') === uniqueArr[index].replace(/\s+/g, '') && !clicked) {
                      option.dispatchEvent(new MouseEvent('click', { bubbles: true })); 
                      clicked = true; 
                      setTimeout(() => {
                          index++; 
                          clickNextOption(); 
                      }, 1500); 
                  } 
              });
      
              if (!clicked) {
                  index++; 
                  setTimeout(clickNextOption, 500); 
              }
          }
      
          clickNextOption(); // Start the process
          document.querySelector(".choose-style-wrapper").parentElement.classList.add("cpb-wrapper");
          const dynamicElement = document.querySelector('.embroidery--button');
          if(filteredOptions.length > 0) {
            clearSelection();
          }
      }

      function observeTargetContainer(targetContainer) {
        const mutationObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.matches(".customize--container")) {
                  observeInsideNode(node);
                }
                if (node.matches(".embroidery--button")) {
                  updateEmbroideryButton();
                }
              }
            });
          });
        });
      
        mutationObserver.observe(targetContainer, { childList: true, subtree: true });
      }
      
      function updateEmbroideryButton() {
        const titleElement = document.querySelector(".embroidery--button .cpb-panel-title");
        if (titleElement) {
            const titleText = titleElement.textContent.trim(); // Get current title
    
            // Check if "Add Embroidery" is already formatted
            if (!titleText.includes("(Embroidery)")) {
                // Preserve the original text but replace "Add Embroidery" with a styled version in parentheses
                const updatedText = titleText.replace(/Add Embroidery/i, `
                    <span class="embroidery--txt">
                        <span style="color: #DD4C45;">A</span>
                        <span style="color: #EBAE60;">d</span>
                        <span style="color: #D6CA34;">d</span>
                        &nbsp;
                        <span style="color: #58A949;">E</span>
                        <span style="color: #2C4FA1;">m</span>
                        <span style="color: #5555BB;">b</span>
                        <span style="color: #863ECA;">r</span>
                        <span style="color: #DA5CDF;">o</span>
                        <span style="color: #DD4C45;">i</span>
                        <span style="color: #E59439;">d</span>
                        <span style="color: #D6CA34;">e</span>
                        <span style="color: #58A949;">r</span>
                        <span style="color: #2C4FA1;">y</span>
                    </span>
                `);
                titleElement.innerHTML = updatedText; // Update the title with styled text
            }
        }
      }

      function applyStyle(styleId, cssContent) {
        let style = document.getElementById(styleId);
        if (!style) {
          style = document.createElement("style");
          style.id = styleId;
          document.head.appendChild(style);
        }
        style.innerHTML = cssContent;
      }
      
      // Updates the text area and its placeholder color based on the selected thread color
      function updateTextAreaColor(selectedColor) {
        const textArea = document.querySelector(".embroidery--text textarea");
        if (textArea) {
          textArea.style.color = selectedColor;
          applyStyle("embroidery-placeholder-style", `
            .embroidery--text textarea::placeholder {
              color: ${selectedColor} !important;
            }
          `);
        }
      }
      
      // Handles thread color updates for color container and placements
      function observeThreadColorChanges() {
        const colorContainer = document.querySelector(".thread--color .cpb-category-options-container");
        const placementElements = document.querySelectorAll(".embroidery--position .option.option-type-img");
      
        if (!colorContainer) {
          console.error("Color container not found.");
          return;
        }
        if (placementElements.length === 0) {
          console.error("No placement elements found.");
          return;
        }
      
        const onColorChange = () => {
          const activeColor = colorContainer.querySelector(".option-type-color.active .cpb-option-type-color-bg");
          if (activeColor) {
            const selectedColor = activeColor.style.getPropertyValue("background-color");
            updateTextAreaColor(selectedColor);
          }
        };
      
        // Observe color container changes
        const colorObserver = new MutationObserver(onColorChange);
        colorObserver.observe(colorContainer, {
          attributes: true,
          subtree: true,
          attributeFilter: ["class"],
        });
      
        // Attach click listeners and trigger immediate updates for placement elements
        placementElements.forEach((element) => {
          element.addEventListener("click", onColorChange);
          onColorChange();
        });
      
        // Observe changes in placement elements
        const placementObserver = new MutationObserver(onColorChange);
        placementElements.forEach((element) => {
          placementObserver.observe(element, {
            attributes: true,
            subtree: true,
            attributeFilter: ["class"],
          });
        });
      }
      // Observes changes inside a specific node
      function observeInsideNode(node) {
        const innerObserver = new MutationObserver((mutations) => {
          mutations.forEach((mutation) => {
            mutation.addedNodes.forEach((innerNode) => {
              if (innerNode.nodeType === Node.ELEMENT_NODE) {
                if (innerNode.matches(".embroidery--text") || innerNode.matches(".thread--color")) {
                  observeThreadColorChanges();
                }
              }
            });
          });
        });
      
        innerObserver.observe(node, { childList: true, subtree: true });
      }
      function getCookie(name) {
        const cookies = document.cookie.split(';');
        for (let cookie of cookies) {
            const [key, value] = cookie.trim().split('=');
            if (key === name) {
                return value;
            }
        }
        return null;
      }
      function changePriceonDiscount(){
        console.log(getCookie('discount_code'),'heyyy');
        if(getCookie('discount_code') == null){
          return
        }
        const priceElement = document.querySelector('.cpb-custom-product-price');
        const addToCartButton = document.querySelector(".cpbc-add-to-cart-button");
        let getRegularProductPrice = document.querySelector(".cpb-regular-product-price").innerText.replace("US", "").replace(".00", "").trim();
        const stickyAddToCartButton = document.querySelectorAll(".cpbc-bottom-actions-new [pro-add-to-cart] .product_price, .before_selection .product_price");

        let getProductPrice = priceElement.innerText.replace("US", "").replace(".00", "").trim();
        // check if shopify has set the discount on the backend.
        if(getCookie('discount_code') != null && localStorage.getItem('discountAmount') != null){
          getProductPrice = parseInt(getProductPrice.split('$')[1]) - parseInt(localStorage.getItem('discountAmount'));
          getProductPrice = '$'+getProductPrice;
          priceElement.innerText = getProductPrice;
          priceElement.dataset.productAmount = getProductPrice;
          document.querySelector(".cpb-regular-product-price").classList.remove("hidden");

          if(document.querySelector('#trynow') != null){
            const orgText = document.querySelector('#trynow').innerHTML;
            if(document.querySelector('#trynow').innerHTML.includes('atc--regular-price')){
              document.querySelector('#trynow .atc--regular-price').innerHTML = getProductPrice;
            } else{
              document.querySelector('#trynow').innerHTML = orgText + `- $0 <s class="atc--regular-price">${getProductPrice}</s> `;
            }
           
          }
        }
        
        if (addToCartButton && getProductPrice != getRegularProductPrice) {
            addToCartButton.innerHTML = `Add To Cart - ${getProductPrice} <span class="atc--regular-price">${getRegularProductPrice}</span>`;
        }

        if(stickyAddToCartButton.length){  
          // stickyAddToCartButton.innerText = getProductPrice;
          stickyAddToCartButton.forEach(element => element.innerText = getProductPrice);
        }
      }
      function embroideryPriceChange() {
        function getCookie(name) {
          const cookies = document.cookie.split(';');
          for (let cookie of cookies) {
              const [key, value] = cookie.trim().split('=');
              if (key === name) {
                  return value;
              }
          }
          return null;
        }
        const priceElement = document.querySelector('.cpb-custom-product-price');
        if (!priceElement) {
            return;
        }
        let timeout;
        const observer = new MutationObserver(mutations => {
            clearTimeout(timeout); 
            timeout = setTimeout(() => {
                observer.disconnect(); 
               
                const addToCartButton = document.querySelector(".cpbc-add-to-cart-button");
                const stickyATCBeforeSelectionButton = document.querySelector(".before_selection .product_price");
                const stickyATCAfterSelectionButton = document.querySelector(".cpbc-bottom-actions-new [pro-add-to-cart] .product_price");
                let getRegularProductPrice = document.querySelector(".cpb-regular-product-price").innerText.replace("US", "").replace(".00", "").trim();
                let getProductPrice = priceElement.innerText.replace("US", "").replace(".00", "").trim();

                // check if shopify has set the discount on the backend.
                if(getCookie('discount_code') != null && localStorage.getItem('discountAmount') != null){
                  getProductPrice = parseInt(getProductPrice.split('$')[1]) - parseInt(localStorage.getItem('discountAmount'));
                  getProductPrice = '$'+getProductPrice;
                }
                let getStickyProductPrice = (getCookie('discount_code') != null && localStorage.getItem('discountAmount') != null) ? `${getProductPrice} <span class="sticky-atc--regular-price">${priceElement.innerText.replace("US", "").replace(".00", "").trim()}</span>` : priceElement.innerText.replace("US", "").replace(".00", "").trim();
                
                if (addToCartButton) {
                    addToCartButton.innerHTML = (getCookie('discount_code') != null && localStorage.getItem('discountAmount') != null) ? `Add To Cart - ${getProductPrice} <span class="atc--regular-price"> ${priceElement.innerText.replace("US", "").replace(".00", "").trim()}</span>` : `Add To Cart - ${getProductPrice}`;
                }

                if(stickyATCBeforeSelectionButton){  
                  // stickyAddToCartButton.innerText = getProductPrice;
                  stickyATCBeforeSelectionButton.innerHTML = getStickyProductPrice;
                }
                if(stickyATCAfterSelectionButton){  
                  // stickyAddToCartButton.innerText = getProductPrice;
                  stickyATCAfterSelectionButton.innerHTML = getProductPrice;
                }
                let originalProPrice = priceElement.dataset.productAmount;
    
                // Restore the original price
                if (originalProPrice) {
                    priceElement.innerText = originalProPrice;
                }
    
                // Reconnect the observer
                observer.observe(priceElement, { childList: true, subtree: true, characterData: true });
            }, 1000); // Short delay to avoid multiple rapid executions
        });
        observer.observe(priceElement, { childList: true, subtree: true, characterData: true });
      }

      function clearSelection() {
        if (embroiderySection && window.universalOptions.length > 0 && localStorage.getItem("discountCode") != null) {
            let prelectionBlock = document.querySelector('.quiz-prelection-block');
            // Find values from window.universalOptions array
            let shoppingConcernsObj = window.universalOptions.find(item => item.Type === "Shopping Concern");
            let fitFlareObj = window.universalOptions.find(item => item.Type === "Fit" || item.Type === "Flare");
            let notesObj = window.universalOptions.find(item => item.Type === "Notes");
            let customRiseObj = window.universalOptions.find(item => item.Type === "custom_Rise");
            let customLengthObj = window.universalOptions.find(item => item.Type === "custom_Length" || item.Type === "custom_length");
            // Extract values or set as empty string if not found
            let shoppingConcerns = shoppingConcernsObj ? shoppingConcernsObj.value : "";
            let fitFlare = fitFlareObj ? fitFlareObj.value : "";
            let notes = notesObj ? notesObj.value : "";
            let customRise = customRiseObj ? customRiseObj.value.split("_")[1] : "";
            let customLength = customLengthObj ? customLengthObj.value.split("_")[1] : "";
    
            const quizData = JSON.parse(localStorage.getItem("quizInfo")) || [];
    
            if (quizData.length > 0) {
                // Create main wrapper
                var selectionTitleDiv = document.createElement("div");
                // selectionTitleDiv.className = "cpb-quiz-selection-title-container";

                // Add title
                var title = document.createElement("p");
                title.className = "cpb-quiz-selection-title";
                title.textContent = "Below are the choices based on your quiz responses";
                selectionTitleDiv.appendChild(title);
                productDescription.insertAdjacentElement("afterend", title);

                // Additional note section

                var selectionDiv = document.createElement("div");
                selectionDiv.className = "cpb-quiz-selection";
    
                // Additional Notes Section
                var additionalNotesSection = document.createElement("div");
                additionalNotesSection.className = "cpb-additional-notes";

                // Add section title
                var additionalNotesTitle = document.createElement("span");
                additionalNotesTitle.className = "additional_notes_title";
                additionalNotesTitle.textContent = "Additional Notes";
                additionalNotesSection.appendChild(additionalNotesTitle);
            
                // Custom Measurements Section (Only if customRise or customLength is not blank)
                if (customRise || customLength) {
                    var customMeasurementsDiv = document.createElement("div");
                    customMeasurementsDiv.className = "cpb-custom-measurements";
                    customMeasurementsDiv.innerHTML = `<span class="custom-title">Custom Measurements</span>`;
    
                    if (customRise) {
                        customMeasurementsDiv.innerHTML += `<p class="measurement_value rise-option">Rise - ${customRise} Inches</p>`;
                    }
                    if (customLength) {
                        customMeasurementsDiv.innerHTML += `<p class="measurement_value length-option">Length - ${customLength} Inches</p>`;
                    }
                   
                    additionalNotesSection.appendChild(customMeasurementsDiv);
                }
    
                // Fit / Flare Section (Only if fitFlare exists)
                if (fitFlare) {
                    var fitFlareSection = document.createElement("div");
                    fitFlareSection.className = "cpb-fit-flare";
                    fitFlareSection.innerHTML = `
                      <span class="custom-title">Fit Preferences</span>
                      <p class="cpb-fit-description">${fitFlare}</p>
                    `;
                    additionalNotesSection.appendChild(fitFlareSection);
                }
    
                // Shopping Concerns Section (Only if shoppingConcerns is not blank)
                if (shoppingConcerns) {
                    var shoppingConcernsDiv = document.createElement("div");
                    shoppingConcernsDiv.className = "cpb-concerns";
                    shoppingConcernsDiv.innerHTML = `
                      <span class="custom-title">My Jean Struggles</span>
                      <p class="shopping-concerns">${shoppingConcerns}</p>
                    `;
                    additionalNotesSection.appendChild(shoppingConcernsDiv);
                }
    
                // General Notes Section (Only if Notes is not blank)
                if (notes) {
                  function truncateText(str, maxLength) {
                    if (str.length > maxLength) {
                      return str.substring(0, maxLength) + '...';
                    }
                    return str;
                  }
                    var generalNotesDiv = document.createElement("div");
                    generalNotesDiv.className = "cpb-general-notes";
                    generalNotesDiv.innerHTML = `
                      <span class="custom-title">My Additional Notes</span>
                      <p class="notes">${notes}</p>
                    `;
                    additionalNotesSection.appendChild(generalNotesDiv);
                }
    
                // Append additionalNotesSection if it has content
                if (additionalNotesSection.innerHTML.trim() !== "") {
                    selectionDiv.appendChild(additionalNotesSection);
                }
    
                // Button inside a styled div
                var selectionButtonWrapper = document.createElement("div");
                selectionButtonWrapper.className = "cpb-button-wrapper";
    
                var selectionButton = document.createElement("button");
                selectionButton.className = "cpb-selection-button";
                selectionButton.textContent = "Clear Your Results";
                selectionButtonWrapper.appendChild(selectionButton);
    
                // Append button wrapper
                selectionDiv.appendChild(selectionButtonWrapper);
      
                // Insert the new div after the product description 
                embroiderySection.insertAdjacentElement("beforebegin", selectionDiv);
    
                // Clear Selection on Button Click
                selectionButton.addEventListener("click", () => {
                    localStorage.removeItem("quizInfo");
                    location.reload();
                });
                
                let getPDPContainer = setInterval(() => {
                  let mainProductContainer = document.querySelector(".product-builder");  
                  if (mainProductContainer) {
                    mainProductContainer.classList.add("no-padding-top", "no-margin-top");
                    clearInterval(getPDPContainer);
                  } 
                }, 1);
            }
            prelectionBlock.classList.remove("hidden");
        }
      }
  
      if (embroideryTitle && !subtext) {
        const subtextElement = document.createElement('p');
        subtextElement.className = 'subtext';
        subtextElement.textContent = 'Add an additional personal touch to your Neems with colorful chainstitch embroidery.'; 
        embroideryTitle.insertAdjacentElement('afterend', subtextElement);
      }

      if (targetContainer) {
        // Process existing elements before observing
        const existingNodes = targetContainer.querySelectorAll(".customize--container, .embroidery--button");
        existingNodes.forEach((node) => {
          if (node.matches(".customize--container")) {
            observeInsideNode(node);
          }
          if (node.matches(".embroidery--button")) {
            updateEmbroideryButton();
          }
        });
        observeTargetContainer(targetContainer);
      } else {
        console.error("Target container not found.");
      }

      document.body.addEventListener('click', function(e) {
        var target = e.target;
        var optionElement = target.closest(".cpb-option-type-text");
        if (optionElement) {
          let embroideryContainer = target.closest(".cpb-option-type-text").closest(".embroidery-button-wrapper");
          if(embroideryContainer) {
            if (!optionElement.classList.contains("cpb-active")) {
                var textDiv = optionElement.querySelector("div");
                if (textDiv) {
                    textDiv.textContent = "Remove Embroidery";
                }
            } else {
                var textDiv = optionElement.querySelector("div");
                if (textDiv) {
                    textDiv.textContent = "Add Embroidery";
                }
            }
          }
        }
        // Check if the clicked element (or its ancestor) is the preview button
        const previewDesignBtn = target.closest(".preview--design");
        if (previewDesignBtn) {
          document.querySelector(".cpb-preview-container").scrollIntoView({ behavior: "smooth" });
        }
      });
      if(document.querySelector(".Style-option") && quizData.length > 0) {
        document.querySelector(".Style-option .cpb-panel-title").innerText = "Your Style";
      }
      document.querySelectorAll(".rise-option, .length-option").forEach((element) => {
        element.querySelectorAll(".cpb-option").forEach((ele) => {
            ele.addEventListener("click", (event) => {
                setTimeout(() => {
                  let parentEle = event.target.closest(".cpb-panel-wrapper");
                  if (parentEle.classList.contains("rise-option")) {
                      const labelElement = ele.querySelector('.cpb-option-label') || 
                                          ele.closest('.option')?.querySelector('.cpb-option-label') || 
                                          ele.querySelector('span > div') || 
                                          ele.querySelector('div');
                                          
                      const labelText = labelElement?.textContent.trim() || ""; 
                      const customRiseIndex = window.universalOptions.findIndex(item => item.Type === "custom_Rise" || item.Type === "custom_rise");
                      if (labelText.includes("Specific")) {
                          if(labelElement.closest(".option").classList.contains("active")) {
                            if(document.querySelector(".cpb-custom-measurements")) {
                              document.querySelector(".cpb-custom-measurements .rise-option").classList.remove("hidden")
                            }
                            delete window.universalOptions[customRiseIndex].addProperty;
                          } else {
                            if(document.querySelector(".cpb-custom-measurements")) {
                              document.querySelector(".cpb-custom-measurements .rise-option").classList.add("hidden")
                            }
                            if(customRiseIndex > -1) {
                              window.universalOptions[customRiseIndex].addProperty = false;
                            }
                          }
                      } else {
                        if(document.querySelector(".cpb-custom-measurements")) {
                          document.querySelector(".cpb-custom-measurements .rise-option").classList.add("hidden")
                        }
                        if(customRiseIndex > -1) {
                          window.universalOptions[customRiseIndex].addProperty = false;
                        }
                      }
                  } else if (parentEle.classList.contains("length-option")) {
                      const labelElement = ele.querySelector('.cpb-option-label') || 
                                          ele.closest('.option')?.querySelector('.cpb-option-label') || 
                                          ele.querySelector('span > div');
      
                      const labelText = labelElement?.textContent.trim() || ""; // Ensure it's a string
                      const customLengthIndex = window.universalOptions.findIndex(item => item.Type === "custom_Length" || item.Type === "custom_length");
                      if (labelText.includes("Specific")) {
                          if(labelElement.closest(".cpb-option").classList.contains("cpb-active")) {
                            if(document.querySelector(".cpb-custom-measurements")) {
                              document.querySelector(".cpb-custom-measurements .length-option").classList.remove("hidden")
                            }
                            delete window.universalOptions[customLengthIndex].addProperty;
                          } else {
                            if(document.querySelector(".cpb-custom-measurements")) {
                              document.querySelector(".cpb-custom-measurements .length-option").classList.add("hidden")
                            }
                            if(customLengthIndex > -1) {
                              window.universalOptions[customLengthIndex].addProperty = false;  
                            }
                          }
                      } else {
                        if(document.querySelector(".cpb-custom-measurements")) {
                          document.querySelector(".cpb-custom-measurements .length-option").classList.add("hidden")
                        }
                        if(customLengthIndex > -1) {
                          window.universalOptions[customLengthIndex].addProperty = false;  
                        }
                      }
                  }
                  const measurementValues = document.querySelectorAll(".measurement_value");
                  const allHidden = [...measurementValues].every(el => el.classList.contains("hidden"));
                  if(allHidden && document.querySelector(".cpb-custom-measurements")) {
                    document.querySelector(".cpb-custom-measurements").classList.add("hidden");
                  } else {
                    if(document.querySelector(".cpb-custom-measurements")){
                      document.querySelector(".cpb-custom-measurements").classList.remove("hidden");
                  }
                    
                  }
                }, 500);
                
            });
        });
      });
    } 
  }

  function selectStyleOptions() {
    const urlParams = new URLSearchParams(window.location.search);
    let style = urlParams.get('style');
    // If the value has quotes, remove them
    if (style) {
      style = style.replace(/^"|"$/g, '');
      const options = document.querySelectorAll(`.Style-option .cpb-option`);
      options.forEach((option) => {
        const label = option.querySelector('.cpb-option-label') || 
                                                      option.closest('.option').querySelector('.cpb-option-label') || 
                                                      option.closest('.option-type-text').querySelector('.cpb-option-type-text > div') ||
                                                      option.querySelector('span > div');
        let finalLabel = label.innerText.toLowerCase().replace(/^"|"$/g, '').replace(" ", "");
        
        if(finalLabel == style) {
          console.log(option, "optionssssss");
          option.click();
        }  
      })
        // // console.log(style, "style");
        // if(label == style) {
        //   console.log(label.innerText.toLowerCase().replace(" ", ""), "label");
        // } 
    }
    
  }

  function tabletPreview () {
    if (window.innerHeight > window.innerWidth && window.innerWidth >= 999) {
      setTimeout(() => {
        const productBuilder = document.querySelector('#product-builder')
        const stickyPreview = document.querySelector('.cpb-preview-sticky')
        const nextSlide = document.querySelector('.cpb-swiper-thumbnails .swiper-slide.swiper-slide-next')
        const style = document.createElement('style');
        const konva = document.querySelector('.cpb-render-konva')
        productBuilder.classList.add('custom-tablets')
        const activeSlide = document.querySelector('.cpb-swiper-thumbnails .swiper-slide.swiper-slide-active')
        activeSlide.style.position = 'absolute'
        style.innerHTML = `
          .cpb-swiper-thumbnails .swiper-slide {
            height: ${nextSlide.offsetWidth}px !important;
          }
          .cpb-custom-tablets-style {}
        `;
        document.head.appendChild(style);
        document.querySelector('.testimonial-wrapper').style.display = 'none'
      }, 0)
    } else {
      const productBuilder = document.querySelector('#product-builder');
      const activeSlide = document.querySelector('.cpb-swiper-thumbnails .swiper-slide.swiper-slide-active');
      const testimonialWrapper = document.querySelector('.testimonial-wrapper');
    
      if (productBuilder) {
        productBuilder.classList.remove('custom-tablets');
      }
    
      if (activeSlide) {
        activeSlide.style.position = '';
      }
    
      const addedStyles = [...document.querySelectorAll('style')].filter(style => style.innerHTML.includes('.cpb-custom-tablets-style'));
    
      addedStyles.forEach(style => style.remove());
    
      if (testimonialWrapper) {
        testimonialWrapper.style.display = '';
      }
    }
}

  function titleSectionChanges() {
    const panelsContainer = $(".cpb-panels-container");
    const title = panelsContainer.find(".cpb-product-title");
    const price = panelsContainer.find(".cpb-product-price");

    //title[0].innerText = title[0].innerText.split('-')[0];
    const titleSection = $('<div class="cpb-custom-title-section">');
    const first = $('<div class="cpb-custom-title-section__first">');
    const second = $('<div class="cpb-custom-title-section__second">');

    const badgeWrapper = $(".cpb-custom-reviews-badge").detach().show();

    const customPrice = $('<span class="cpb-custom-product-price">');
    const customRegularPrice = $('<span class="cpb-regular-product-price hidden">');

    const afterpay = $(`<afterpay-placement 
            data-show-upper-limit="false"
            data-logo-type="compact-badge"
            data-amount="${getProductPrice()}"
            data-size="sm"
            style="--logo-badge-width:85px"
            data-is-eligible="{%if productIsIneligible%}false{%else%}true{%endif%}"
            data-locale="en_US"
            data-currency="USD">
      </afterpay-placement>`);

    const observer = new MutationObserver(function () {
      afterpay.attr("data-amount", getProductPrice());
      customPrice.text(price.text());
     
    });
    observer.observe(price[0], {
      subtree: true,
      childList: true,
      characterData: true,
    });

    customPrice.text(price.text());
    customRegularPrice.text(price.text());
    customPrice.attr("data-product-amount", price.text().replace("US", "").replace(".00", "").trim());

    titleSection.append(first, second);

    if (title.length > 0) first.append(title);

    if (badgeWrapper.length > 0) first.append(badgeWrapper);

    second.append(customPrice, afterpay);
    second.append(customRegularPrice, afterpay);

    panelsContainer.prepend(titleSection);

    $("#product-builder").attr("data-custom-title-changes", true);

    function getProductPrice() {
      return CPB.getStore().getState().Product.price;
    }
  }
})(jQuery, Swal);

if (document.querySelector("[data-product-type]") && document.querySelector("[data-product-type]").dataset.productType == "men") {
  var swiper = new Swiper(".mySwiper", {
    slidesPerView: 'auto',
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: true,
    dots: true,
    paginationClickable: true,
    centeredSlides: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      767: {
        slidesPerGroup: 2,
      },
      998: { 
        slidesPerGroup: 1,
      },
      1250: {
        slidesPerGroup: 2,
      }
    }
  });
} else {
  var swiper = new Swiper(".mySwiper", {
  slidesPerView: 'auto',
  slidesPerGroup: 2,
  spaceBetween: 20,
  loop: true,
  dots: true,
  paginationClickable: true,
  centeredSlides: false,
  pagination: {
    el: '.swiper-pagination',
    clickable: true
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
  breakpoints: {
    767: {
      slidesPerGroup: 3,
    },
    998: { 
      slidesPerGroup: 2,
    },
    1250: {
      slidesPerGroup: 3,
    }
  }
});
}

// var swiper = new Swiper(".mySwiper", {
//   slidesPerView: 'auto',
//   slidesPerGroup: 2,
//   spaceBetween: 20,
//   loop: true,
//   dots: true,
//   paginationClickable: true,
//   centeredSlides: false,
//   pagination: {
//     el: '.swiper-pagination',
//     clickable: true
//   },
//   navigation: {
//     nextEl: ".swiper-button-next",
//     prevEl: ".swiper-button-prev",
//   },
//   breakpoints: {
//     767: {
//       slidesPerGroup: 3,
//     },
//     998: { 
//       slidesPerGroup: 2,
//     },
//     1250: {
//       slidesPerGroup: 3,
//     }
//   }
// });


class announcementBar extends HTMLElement {
  constructor() {
      super();
      this.init();
  }

  init() {
      // Target element you want to observe
      const targetElement = document.querySelector('announcement-bar');
      let discountAmount = localStorage.getItem("discountAmount") ? `$${localStorage.getItem("discountAmount")}` : "";
      let discountCode = localStorage.getItem("discountCode") ? `${localStorage.getItem("discountCode")}` : "";

      // Callback function for Intersection Observer
      const callback = (entries) => {
      entries.forEach((entry) => {
          if (entry.isIntersecting) {
              const durationMinutes = 60; // Set the timer duration (can be n minutes)
              this.productBlock = document.querySelector('.product-block');
              // this.startTimer(durationMinutes);
              // Add your desired action here
          } 
      });
      };

      // Options for the observer
      const options = {
      root: null, 
      rootMargin: '0px',
      threshold: 0.1 
      };

      // Create an Intersection Observer
      const observer = new IntersectionObserver(callback, options);

      // Start observing the target element
      if (targetElement) {
          observer.observe(targetElement);
      }

     if(discountAmount != '' && discountCode != ''){
        document.querySelectorAll("[data-discount-ammount]").forEach((element) => {
          element.innerText = discountAmount;
        });
        document.querySelectorAll(`.discount_code`).forEach((element) => {
          element.innerText = discountCode;
        });
      } else{
        document.querySelector('announcement-bar').remove();
      }

      const findTBYB = setInterval(()=>{
        if(document.querySelector('#trynow') != null){
          clearInterval(findTBYB);
          const orgText = document.querySelector('#trynow').innerHTML;
          if(!orgText.includes('atc--regular-price')){
            const productPrice = document.querySelector(".cpb-custom-product-price").innerText.replace("US", "").replace(".00", "").trim();
            document.querySelector('#trynow').innerHTML = orgText + `- $0 <s class="atc--regular-price">${productPrice}</s> `;
          }
        }
      },50)     
  }

  setCookie(name, value, minutes) {
      const expires = new Date();
      expires.setTime(expires.getTime() + minutes * 60 * 1000);
      document.cookie = `${name}=${value};expires=${expires.toUTCString()};path=/`;
  }

  getCookie(name) {
      const cookies = document.cookie.split(';');
      for (let cookie of cookies) {
          const [key, value] = cookie.trim().split('=');
          if (key === name) {
              return value;
          }
      }
      return null;
  }

  // startTimer(durationMinutes) {
  //     const now = Date.now();
  //     let timerEndTime = parseInt(this.getCookie('quizOffer'));
  
  //     // Check if the timer cookie is missing or expired
  //     if (!timerEndTime || timerEndTime <= now) {
  //         timerEndTime = now + durationMinutes * 60 * 1000;
  //         this.setCookie('quizOffer', timerEndTime, durationMinutes);
  //     }
  
  //     const updateTimer = () => {
  //         const remainingTime = timerEndTime - Date.now();
  //         if (remainingTime <= 0) {
  //             clearInterval(timerInterval);
  
  //             // Hide timer and clear cookie when expired
  //             document.querySelectorAll("announcement-bar [data-timer]").forEach((element) => {
  //                 element.classList.add("hidden");
  //             });
  //             document.cookie = "quizOffer=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  //             return;
  //         } else {
  //             // Show timer if active
  //             document.querySelectorAll("announcement-bar [data-timer]").forEach((element) => {
  //                 element.classList.remove("hidden");
  //             });
  //         }
  
  //         const minutes = Math.floor(remainingTime / (1000 * 60)).toString().padStart(2, '0');
  //         const seconds = Math.floor((remainingTime % (1000 * 60)) / 1000).toString().padStart(2, '0');
  //         document.querySelectorAll("announcement-bar .minutes").forEach((element) => {
  //             element.innerText = minutes;
  //         });
  //         document.querySelectorAll("announcement-bar .seconds").forEach((element) => {
  //             element.innerText = seconds;
  //         });
  //         document.querySelectorAll(".timer_value").forEach((element) => {
  //             element.innerText = `${minutes}:${seconds}`;
  //         });
  //     };
  
  //     // Start the timer update logic
  //     updateTimer();
  //     const timerInterval = setInterval(updateTimer, 1000);
  // }
  
}

customElements.define('announcement-bar', announcementBar);

const fixMobilePreview = () => {
const builder = document.querySelector('#product-builder');
const previewWrapper = document.querySelector('.cpb-preview-wrapper');
const previewElements = document.querySelector('.cpb-preview-elements');

const update = () => {    
  const activeSlideCanvas = previewWrapper.querySelectorAll('.swiper-slide-active canvas');
  if (activeSlideCanvas.length == 0) return;
  const ratio = activeSlideCanvas[0].width/activeSlideCanvas[0].height;
  const newWidth = innerWidth;
  const newHeight = newWidth/ratio;

  if (innerWidth > 999) {
    document.querySelector('.cpb-layout').style.setProperty('--custom-scale-preview', `${ratio}`);
    return
  }
  
  previewElements.style.paddingTop = `${newHeight}px`;
  activeSlideCanvas.forEach(canvas => {
    canvas.style.width = `${newWidth}px`;
    canvas.style.height = `${newHeight}px`;  
  })    
  
  const konvaJSContentElems = document.querySelectorAll('.konvajs-content');
  konvaJSContentElems.forEach(el => {
    el.style.width = '100%';
    el.style.height = '100%';
  });
}

let initialyUpdated = false;

document.body.addEventListener('CPB_ON_KONVA_READY', function(event) {
  // console.log('CPB_ON_KONVA_READY');
  setTimeout(() => {
    new MutationObserver(() => {
      console.log('observer');
      setTimeout(update);
    }).observe(document.querySelector('.swiper-slide canvas'), {attributes: true, attributeFilter: ['width']});
  }, 500); 
});
document.body.addEventListener('CPB_ON_UPDATE_CURRENT_VIEW', function(event) {
  // console.log('CPB_ON_UPDATE_CURRENT_VIEW');
  setTimeout(update);
});
document.body.addEventListener('CPB_ON_RENDER_LAYERS', function(event) {
  // console.log('CPB_ON_RENDER_LAYERS');
  if (!initialyUpdated) {
    setTimeout(update);
    initialyUpdated = true;
  }
});
document.body.addEventListener('CPB_ON_OPTIONS_UPDATE', function(event) {
  // console.log('CPB_ON_OPTIONS_UPDATE');
  setTimeout(update);
});


}

document.body.addEventListener('CPB_ON_PRODUCT_MOUNTED', function(event) {
fixMobilePreview();
})

























